import moment from "moment";
import i18n from "@/i18n";
import { IStatRange } from "@/models/stats";
import store from "@/store";
import Vue from "vue";

declare module "vue/types/vue" {
  interface Vue {
    timeNow: Date;
    currentQuarter: number;
    startOfTheDay: Date;
    endOfTheDay: Date;
    timeStamp: number;
    ranges: { [key: string]: IStatRange };
  }
}

const component = new Vue({
  computed: {
    timeNow() {
      return store.state.utils.time.now;
    },
    currentQuarter() {
      return moment(this.timeNow).quarter();
    },
    startOfTheDay() {
      return moment(this.timeNow)
        .startOf("day")
        .toDate();
    },
    endOfTheDay() {
      return moment(this.timeNow)
        .endOf("day")
        .toDate();
    },
    timeStampEndOfDay() {
      return this.endOfTheDay.getTime();
    },
    ranges(): { [key: string]: IStatRange } {
      return {
        last24h: {
          key: "last24h",
          label: i18n.t("_.today"),
          dateFrom: this.startOfTheDay,
          dateTo: this.endOfTheDay,
          group: "hour",
          needsEndDate: false
        } as IStatRange,
        last7days: {
          key: "last7days",
          label: i18n.t("_.last_7_days"),
          dateFrom: moment(this.startOfTheDay)
            .add(-7, "days")
            .startOf("day")
            .toDate(),
          dateTo: this.endOfTheDay,
          group: "day",
          BEFilter: "-7_days"
        } as IStatRange,
        last30days: {
          key: "last30days",
          label: i18n.t("_.last_30_days"),
          dateFrom: moment(this.startOfTheDay)
            .add(-30, "days")
            .startOf("day")
            .toDate(),
          dateTo: this.endOfTheDay,
          group: "day",
          BEFilter: "-30_days"
        } as IStatRange,
        monthToDate: {
          key: "monthToDate",
          label: i18n.t("_.month_to_date"),

          dateFrom: moment(this.startOfTheDay)
            .startOf("month")
            .startOf("day")
            .toDate(),
          dateTo: this.endOfTheDay,
          group: "day"
        } as IStatRange,
        last3months: {
          BEFilter: "-3_months",
          dateFrom: moment(this.startOfTheDay)
            .add(-3, "months")
            .startOf("day")
            .toDate(),
          dateTo: this.endOfTheDay,
          group: "month",
          key: "last3months",
          label: i18n.t("_.last_3_months")
        } as IStatRange,
        quarterToDate: {
          key: "quarterToDate",
          label: i18n.t("_.quarter_to_date"),
          dateFrom: moment(this.startOfTheDay)
            .quarter(this.currentQuarter)
            .startOf("quarter")
            .toDate(),
          dateTo: this.endOfTheDay
        } as IStatRange,
        lastQuarter: {
          key: "lastQuarter",
          label: i18n.t("_.previous_quarter"),
          dateFrom: moment(this.startOfTheDay)
            .quarter(this.currentQuarter - 1)
            .startOf("quarter")
            .toDate(),
          dateTo: moment(this.startOfTheDay)
            .quarter(this.currentQuarter - 1)
            .endOf("quarter")
            .toDate(),
          group: "month"
        } as IStatRange,
        yearToDate: {
          key: "yearToDate",
          label: i18n.t("_.year_to_date"),
          dateFrom: moment(this.startOfTheDay)
            .startOf("year")
            .toDate(),
          dateTo: this.endOfTheDay,
          group: "month"
        } as IStatRange,
        lastYear: {
          key: "lastYear",
          label: i18n.t("_.last_year"),
          dateFrom: moment(this.startOfTheDay)
            .add(-1, "year")
            .startOf("year")
            .toDate(),
          dateTo: moment(this.startOfTheDay)
            .add(-1, "year")
            .endOf("year")
            .toDate(),
          group: "month"
        } as IStatRange
      };
    }
  },
  watch: {
    timeStampEndOfDay() {
      this.$emit("day-changed");
    }
  }
});
export default component;
